export interface ValidationRule {
  validate: (value: any) => boolean
  message: string
}

export const required = (message = 'This field is required'): ValidationRule => ({
  validate: (value: any) => value !== null && value !== undefined && value !== '',
  message: message
})

export const email = (message = 'Please enter a valid email address'): ValidationRule => ({
  validate: (value: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value),
  message
})

export const Amount = (message = 'Please enter a Amount Greated than 0'): ValidationRule => ({
  validate: (value: number) => value > 0,
  message
})
export interface ValidationRule {
  validate: (value: any) => boolean;
  message: string;
}

export const minLength = (min: number): ValidationRule => ({
  validate: (value: any) => typeof value === 'string' && value.length > min,
  message: `This field must be at least ${min} characters long.`
});

export const maxLength = (max: number): ValidationRule => ({
  validate: (value: any) => typeof value === 'string' && value.length < max,
  message: `This field can be only ${max} characters long.`
});

export const min = (min: number): ValidationRule => ({
  validate: (value: any) => typeof value === 'number' && value > min,
  message: `This field must be minimumn ${min}.`
});

export const max = (max: number): ValidationRule => ({
  validate: (value: any) => typeof value === 'number' && value < max,
  message: `This field must be maximum ${max}.`
});
